import React from 'react';
import { Play } from 'lucide-react';

export type RoastStage = 'idle' | 'turning' | 'yellow' | 'firstCrack' | 'endReady' | 'ended';

/** Shared base classes for the stopwatch's main/restart buttons. */
export const STOPWATCH_BUTTON_BASE =
  'h-14 flex items-center justify-center active:scale-95 rounded transition-colors duration-100 font-medium';

/** Formats seconds (with fractional ms) as MM:SS:CC. */
export const formatStopwatchTime = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const secs = Math.floor(time % 60);
  const ms = Math.floor((time % 1) * 100); // 2 digit
  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}:${String(ms).padStart(2, '0')}`;
};

/** Button color classes for the current roast stage. */
export const getStageStyle = (stage: RoastStage): string => {
  switch (stage) {
    case 'turning':
      return 'bg-blue-600 text-white hover:bg-blue-700';
    case 'yellow':
      return 'bg-yellow-400 text-black hover:bg-yellow-500';
    case 'firstCrack':
      return 'bg-amber-700 text-white hover:bg-amber-800';
    case 'endReady':
      return 'bg-red-600 text-white hover:bg-red-700';
    case 'ended':
      return 'bg-gray-800 text-white';
    default:
      return 'bg-gray-300 text-gray-700 hover:bg-gray-400';
  }
};

/** Label (or play icon when idle) for the current roast stage's main button. */
export const getStageText = (stage: RoastStage): React.ReactNode => {
  switch (stage) {
    case 'turning':
      return 'Turning Point';
    case 'yellow':
      return 'Yellow';
    case 'firstCrack':
      return 'First Crack';
    case 'endReady':
      return 'End';
    case 'ended':
      return 'Finished';
    default:
      return <Play className="w-5" />;
  }
};
